export type ScreenSize = 'xxs' | 'xs' | 'sm' | 'md' | 'lg';

export const SCREEN_SIZE_BREAKPOINT: Record<ScreenSize, number> = {
    xxs: 375,
    xs: 576,
    sm: 768,
    md: 992,
    lg: 1200,
};
